import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import type { Language } from '@mefosa/shared'
import en from './en.json'
import ar from './ar.json'

/**
 * Language is a per-user preference stored on the user record, so it follows
 * them across devices. localStorage only caches the last choice to avoid a
 * flash of the wrong language before /api/auth/me resolves.
 */
const CACHE_KEY = 'mefosa.lang'

export function cachedLanguage(): Language {
  try {
    const v = localStorage.getItem(CACHE_KEY)
    return v === 'ar' ? 'ar' : 'en'
  } catch {
    return 'en'
  }
}

export function cacheLanguage(lang: Language): void {
  try {
    localStorage.setItem(CACHE_KEY, lang)
  } catch {
    // Private browsing - the server preference still applies after sign-in.
  }
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ar: { translation: ar } },
  lng: cachedLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
})

/** Applies direction and lang to <html> so native controls and fonts follow. */
export function applyDocumentLanguage(lang: Language): void {
  const dir = lang === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.setAttribute('lang', lang)
  document.documentElement.setAttribute('dir', dir)
}

export default i18n
